import { DOCUMENT_TYPES } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useDocumentTypes = () => {
  const { data: queryData, ...rest } = useQuery(DOCUMENT_TYPES);

  const documentTypes = queryData?.documentTypes;

  return { documentTypes, ...rest };
};
